import { render } from "./CheckboxInput.vue?vue&type=template&id=1fa748f7&scoped=true"
import script from "./CheckboxInput.vue?vue&type=script&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=1fa748f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa748f7"]])

export default __exports__